import React, { useEffect, useState } from 'react'
import { useViewport } from '../../utils'
import { GalleryPopup } from '.'
import { ArrayChecker } from '../array-checker'
import { useSelector } from 'react-redux'
import { GalleryItems } from './gallery-items'

// const fallbackImages = [
//   '/images/articles/khub_artikel_1.jpg',
//   '/images/articles/khub_artikel_2.jpg',
//   '/images/articles/khub_artikel_3.jpg',
//   '/images/articles/khub_artikel_4.jpg',
//   '/images/articles/khub_artikel_1.jpg',
//   '/images/articles/khub_artikel_2.jpg',
//   '/images/articles/khub_artikel_3.jpg',
//   '/images/articles/khub_artikel_4.jpg',
// ]

const GallerySection = ({ defaultImages }) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const { isMobile } = useViewport()
  const [initialSlide, setInitialSlide] = React.useState(0)
  const [show, setShow] = React.useState(false)
  const height = isMobile ? '66px' : '100px'
  const [images, setImages] = useState([])

  useEffect(() => {
    if(defaultImages && defaultImages.length > 0){
      setImages(defaultImages.map(image => image.url))
    }
  }, [defaultImages])

  const handlePopup = (index) => {
    setInitialSlide(index)
    setShow(true)
  }

  return (
    <div>
      <h2 className="text-lg lg:text-2xl mb-8 uppercase font-bold">
        {translation.GENERAL.gallery[language.name]}
      </h2>
      <ArrayChecker data={images}>
        <GalleryItems data={images} height={height} handlePopup={handlePopup}/>
        {
          show &&
          <GalleryPopup onClose={setShow} isMobile={isMobile} images={images} initialSlide={initialSlide}/>
        }
      </ArrayChecker>
    </div>
  )
}

export { GallerySection }
